import { z } from "zod";

export const ADMIN_PAGE_SIZES = [25, 50, 100] as const;
export const adminPaginationSchema = z.object({
  page: z.number().int().min(1).max(1_000_000).default(1),
  pageSize: z.union([z.literal(25), z.literal(50), z.literal(100)]).default(25),
});

export function parseAdminPagination(search: Record<string, unknown>) {
  const parsed = adminPaginationSchema.safeParse({
    page: search["page"] === undefined ? 1 : Number(search["page"]),
    pageSize: search["pageSize"] === undefined ? 25 : Number(search["pageSize"]),
  });
  return parsed.success ? parsed.data : { page: 1, pageSize: 25 as const };
}

export function adminPageRange(page: number, pageSize: number) {
  const from = (page - 1) * pageSize;
  return { from, to: from + pageSize - 1 };
}

export function adminPageCount(total: number, pageSize: number) {
  return Math.max(1, Math.ceil(total / pageSize));
}

// List views intentionally exclude article bodies, galleries and SEO copy.
export const ADMIN_CONTENT_LIST_FIELDS =
  "id, slug, published, published_at, content_translations(locale, title)";